import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import LinearProgress from "@mui/material/LinearProgress";
import { divProgressHide, divProgressShow } from "../../css/additional.js";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
  getCurrentTeacher,
  getCurrentOrg,
  api2TeacherDocs, api2ClassesByOrganizationId,
} from "../../utils/operations.js";

import API from '../../utils/api';

import InputMask from 'react-input-mask';
import { api2TeacherPatch } from '../../utils/operations';
import { toast } from 'react-toastify';
import {checkEmail} from "../../utils/misc";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from "moment/moment";
import {ExpandedField} from "../../components/ExpandedField";
import appRoutes from "../../utils/appRoutes";
import {NavLink} from "react-router-dom";
import {TEACHER_DOC_DOH_TYPE, TEACHER_DOC_MEDICAL_TYPE} from "../../utils/constants";

class EditTeacher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        photo: "",
        photofile: "",
        firstname: "",
        lastname: "",
        birthday: new Date(),
        organisation: "",
        classes: "",
        email: "",
        phone: "",
        address: "",
      },
      docs_medical: [],
      docs_doh: [],
      opendialog: false,
      texterrors: "",
      organisations: [], // Список организаций
      classes: [],
      currentOrgClasses: [],
      showProgress: true,
    };

    this.teacherId = this.props.match.params.id;
  }

  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ showProgress: false });
    this.setState({ opendialog: false });
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    let orgId = this.props.Auth.orgId;

    const teacherId = this.props.match.params.id;

    axios
      .all([
        API.get(getCurrentTeacher + teacherId),
        API.get(api2TeacherDocs(teacherId)),
        API.get(getCurrentOrg + orgId),
        API.get(api2ClassesByOrganizationId(orgId))
      ])
      .then(
        axios.spread((teacher, docs, organisations, classes) => {
          let data = teacher.data;
          let teacherDocs = docs.data.data;
          let gotClasses = classes.data.data;
          let gotOrg = organisations.data;
          let relationClasses = [];
          let currentOrgClasses = [];

          for (let j = 0; j < gotClasses.length; j++) {
            if (gotOrg.id === gotClasses[j].organisation_id) {
              relationClasses.push(gotClasses[j]);

              if (gotClasses[j].id === data.classes_id) {
                data.classes_name = gotClasses[j].name;
              }
            }

            if (gotOrg.id === data.organisation_id) {
              data.organisation_name = gotOrg.name;
            }

            if (data.organisation_id === gotOrg.id) {
              currentOrgClasses.push(gotClasses[j]);
            }
          }
          gotOrg.classes = relationClasses;

          if (data.photo !== "undefined") {
            data.photofile = data.photo;
            data.photo = "undefined";
          }

          if (data.birthday) {
            data.birthday = new Date(data.birthday);
          }

          this.setState({
            currentOrgClasses,
            organisations: gotOrg,
            classes: gotClasses,
            data,
            docs_medical: teacherDocs.medical,
            docs_doh: teacherDocs.doh,
            showProgress: false
          });
        })
      );
  };

  deleteData = () => {
    const teacherId = this.state.data.id;
    this.setState({ opendialog: false });

    API.delete(getCurrentTeacher + teacherId).then(() => {
      toast.success("Teacher deleted successfully.")
      this.props.history.push("/teachers");
    }).catch(() => {
      toast.error("Something went wrong.")
    });
  };

  saveData = async () => {
    const teacherId = this.props.match.params.id;

    if (!checkEmail(this.state.data.email)) {
      toast.error("Email must be valid!")
      return;
    }

    let data = {
      firstname: this.state.data.firstname,
      lastname: this.state.data.lastname,
      organisation_id: this.state.data.organisation,
      classes_id: this.state.data.classes_id,
      email: this.state.data.email,
      phone: this.state.data.phone,
      address: this.state.data.address,
      birthday: moment(this.state.data.birthday).format("YYYY-MM-DD"),
    };

    this.setState({ showProgress: true });
    try {
      await API.patch(api2TeacherPatch(teacherId), data)

      toast.success("Teacher edited successfully.")
      setTimeout(this.props.history.push("/teachers"), 1000);
    } catch (e) {
      toast.error("Something wrong. Please try again.")
    } finally {
      this.setState({ showProgress: true });
    }

  };

  handleOrgChange = (event, index, value) => {
    const data = this.state.data;
    data.organisation_id = value;
    data.classes = "";
    this.setState({ data });

    const currentOrgClasses = this.state.organisations[index].classes;
    this.setState({ currentOrgClasses });
  };

  handleClassChange = (event, index, value) => {
    const data = this.state.data;
    data.classes_id = value;
    this.setState({ data });
  };

  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;

    this.setState({ data });
  };

  handleBirthday = (birthday) => {
    const data = this.state.data;
    data.birthday = birthday;
    this.setState({ data });
  };

  goPreviousPage = () => {
    this.props.history.goBack();
  };


  render() {
    return (
      <div style={{ width: 500, margin: "auto" , paddingBottom: '40px' }}>
        <div
          style={this.state.showProgress ? divProgressShow : divProgressHide}
        >
          <LinearProgress />
        </div>
        <br />
        <TextField
          id="firstname"
          label="First Name"
          error={!this.state.data.firstname}
          helperText={!this.state.data.firstname ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.firstname}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <TextField
          id="lastname"
          label="Last Name"
          error={!this.state.data.lastname}
          helperText={!this.state.data.lastname ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.lastname}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Birthday"
            value={this.state.data.birthday}
            onChange={this.handleBirthday}
            slotProps={{ textField: { fullWidth: true, variant: "standard" } }}
          />
        </LocalizationProvider>
        <br />
        <FormControl fullWidth variant="standard">
          <InputLabel id="organisation-label">School</InputLabel>
          <Select
            labelId="organisation-label"
            id="organisation"
            error={!this.state.organisations.id}
            value={this.state.organisations.id}
            onChange={(e) => this.handleOrgChange(e, 0, e.target.value)}
          >
            <MenuItem
              key={this.state.organisations.id}
              value={this.state.organisations.id}
            >
              {this.state.organisations.name}
            </MenuItem>
          </Select>
        </FormControl>
        <br />
        <FormControl fullWidth variant="standard">
          <InputLabel id="classes-label">Class</InputLabel>
          <Select
            labelId="classes-label"
            id="classes"
            error={!this.state.data.classes_id}
            value={this.state.data.classes_id}
            onChange={(e) => this.handleClassChange(e, 0, e.target.value)}
          >
            {this.state.currentOrgClasses.map(rows => (
              <MenuItem key={rows.id} value={rows.id}>{rows.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <br />
        <TextField
          id="email"
          label="Email"
          fullWidth={true}
          value={this.state.data.email}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <InputMask
          mask="999-999-9999 ext. 999"
          fullWidth={true}
          value={this.state.data.phone}
          onChange={this.handleChange}
          id="phone"
          disabled={false}
        >
          {(inputProps) => <TextField {...inputProps} label="Phone" variant="standard" />}
        </InputMask>
        <br />
        <TextField
          id="address"
          label="Address"
          fullWidth={true}
          value={this.state.data.address}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={this.saveData}
          >
            Save
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "#ffd699" }}
            onClick={this.goPreviousPage}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={this.handleOpen}
          >
            Delete
          </Button>
        </div>

        <div>
          <ExpandedField
            title='Medical records'
            style={{ marginTop: '20px'}}
            onAddClick={() => this.props.history.push(appRoutes.teacherMedicalDoc(this.teacherId, TEACHER_DOC_MEDICAL_TYPE))}
            onAddTitle='Add Medical Record'
          >
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>Expiration date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.docs_medical.map((row, index) => (
                  <TableRow
                    key={'medical-record-' + index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell scope="row">
                      <NavLink to={appRoutes.teacherMedicalDocEdit(this.teacherId, row.id, TEACHER_DOC_MEDICAL_TYPE)}>{row.title}</NavLink>
                    </TableCell>
                    <TableCell scope="row">{row.expiration_date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ExpandedField>

          <ExpandedField
            title='DOH paperwork'
            style={{ marginTop: '20px'}}
            onAddClick={() => this.props.history.push(appRoutes.teacherMedicalDoc(this.teacherId, TEACHER_DOC_DOH_TYPE))}
            onAddTitle='Add DOH paperwork'
          >
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>Expiration date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.docs_doh.map((row, index) => (
                  <TableRow
                    key={'medical-record-' + index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell scope="row">
                      <NavLink to={appRoutes.teacherMedicalDocEdit(this.teacherId, row.id, TEACHER_DOC_DOH_TYPE)}>{row.title}</NavLink>
                    </TableCell>
                    <TableCell scope="row">{row.expiration_date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ExpandedField>

        </div>

        <Dialog
          open={this.state.opendialog}
          onClose={this.handleClose}
          maxWidth="xs"
        >
          <DialogContent>
            Are you sure you want to delete the teacher?
          </DialogContent>
          <DialogActions>
            <Button onClick={this.deleteData} color="primary">
              OK
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(EditTeacher))
